import BestValueBadge from './BestValueBadge';

export default BestValueBadge;
